<template>
  <div class="home">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Tarea')" v-loading="cambios_load"
        element-loading-text="Guardando cambios ...">
        <el-row>
          <el-col :md="24">
            <StepsInventario v-bind:step="0" />
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :md="24">
            <el-form onsubmit="return false;" label-position="top">
              <b>
                <el-form-item label="Nombre de la tarea"
                  :class="{ intermitente: taskName === '' ? true : false }">
                  <el-input size="small"
                    placeholder="Ingrese nombre de la tarea" v-model="taskName"></el-input>
                  <br />
                  <span v-if="taskName === ''" class="messageTask fontRed">(*) Ingresa el nombre de la tarea para
                    continuar.</span>
                </el-form-item>
              </b>
            </el-form>
          </el-col>
        </el-row>

        <h4 style="font-size: 14px;" v-if="taskName !== ''" class="help-instructions">
          Seleccione el o los
          <b>Riesgos estandarizados</b> que se apliquen a su tarea. En caso de
          no encontrar alguno, puede ingresar un <b>Nuevo Riesgo</b> o
          <b>Aspecto Ambiental</b> a su tarea.
        </h4>

        <br />
        <el-row :gutter="20" v-if="taskName !== ''">
          <el-col :md="11">
            <h1 style="font-size: 14px;">Riesgos estandarizados</h1>
            <br />
            <el-button icon="el-icon-plus" @click="openDialogAddHealthRisks" size="small" class="colorSalud">Salud
            </el-button>
            <el-button icon="el-icon-plus" @click="openDialogAddSecurityRisk" size="small" class="colorSeguridad">
              Seguridad</el-button>
            <el-button icon="el-icon-plus" @click="openDialogAddMediambienteRisks" size="small"
              class="colorMedioambiente">
              Medioambiente
              <!-- Salud y Seguridad -->
            </el-button>
          </el-col>
          <el-col :md="10">
            <h1 style="font-size: 14px;">Nuevo Riesgo</h1>
            <br />
            <el-button @click="openDialogAddCustomRisk" icon="el-icon-plus" size="small" class="colorCustom">Agregar
              riesgo</el-button>
          </el-col>
        </el-row>

        <br />
        <br />
        <el-button v-if="riesgos.length > 0" @click="openCopyRiskList()" style="margin-right: 20px;"
          icon="el-icon-refresh" type="primary" size="small">Copiar los riesgos seleccionados a otra tarea</el-button>
        <span style="font-size: 14px;" v-if="taskName !== ''">
          Cantidad de riesgos:
          <b>{{ cantidadRiesgos }}</b>
        </span>
        <el-table :key="render" ref="multipleTable" @selection-change="handleSelectionChangeTareas"
          empty-text="Sin riesgos registrados" v-if="taskName !== ''" :max-height="700" class="tableRisks" :data="$store.getters.inventario.tareas[$store.getters.selectedIndexTask]
            .riesgos
            " style="width: 100%; font-size: 13px;" row-class-name="rowClassTablaPloma" :cell-class-name="pintar"
          header-cell-class-name="header-cell-class-table-gray">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column fixed type="expand" width="40" label="+" align="center" :key="componentKey">
            <template slot-scope="scope">
              <div style="padding-left: 30px; padding-right: 30px; padding-bottom: 20px;">
                <el-row>
                  <el-col :span="8">
                    <h4>Causas</h4>
                    <ol>
                      <li v-for="(item, index) in scope.row.causas" :key="index">
                        {{ item.nombre }}
                      </li>
                    </ol>
                  </el-col>
                  <el-col :span="8">
                    <h4>Controles Preventivos</h4>
                    <ol>
                      <li :class="{ fontRed: control.critico }" v-for="(control, i) in getControlesPreventivos(
                        scope.row
                      )" v-bind:key="i">
                        {{ control.nombre }}
                      </li>
                    </ol>
                  </el-col>
                  <el-col :span="8">
                    <h4>Controles Mitigadores</h4>
                    <ol>
                      <li :class="{ fontRed: control.critico }" v-for="(control, i) in getControlesMitigadores(
                        scope.row
                      )" v-bind:key="i">
                        {{ control.nombre }}
                      </li>
                    </ol>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-table-column>
          <el-table-column fixed width="140" align="center" label="Ordenar">
            <template slot-scope="scope">
              <el-button style="font-size: 15px;" plain size="mini" type="success"
                @click="moveUp(scope.$index, scope.row)" icon="el-icon-top" />
              <el-button style="font-size: 15px;" plain size="mini" type="danger"
                @click="moveDown(scope.$index, scope.row)" icon="el-icon-bottom" />
              <br>
            </template>
          </el-table-column>
          <el-table-column fixed width="200" align="center">
            <template slot-scope="scope">
              <el-button size="small" plain type="danger" @click="deleteRisk(scope.row)" icon="el-icon-delete" />
              <el-button
                v-if="!(!scope.row.custom && scope.row.impactos.length > 0 && [4, 5, '4', '5'].includes(scope.row.impactos[0]['mfl']))"
                size="small" plain type="info" @click="openEditRisk(scope.row)" icon="el-icon-edit" />
              <div style="margin-top: 8px;">
                <el-button v-if="riesgos.length === 0" size="small" plain type="primary"
                  @click="openCopyRisk(scope.row)" icon="el-icon-refresh">
                  Copiar en otra tarea</el-button>
              </div>
              <div style="margin-top: 8px;">
                <el-button v-if="['coordinator', 'contractor_coordinator'].includes($store.getters.role.role)"
                  type="warning" size="small" @click="copyRisks(scope.row)">{{ $t("Copiar a otro inventario")
                  }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="590" prop="nombre" label="Nombre" />
          <el-table-column width="120" align="center" label="Tipo">
            <template slot-scope="scope">
              <el-tag size="medium" type="danger" v-if="!scope.row.custom">Estandarizado</el-tag>
              <el-tag size="medium" type="success" v-else>Personalizado</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="Impacto">
            <template slot-scope="scope">{{
              getMayorImpacto(scope.row).mfl
            }}</template>
          </el-table-column>
          <el-table-column width="100" align="center" label="MFL">
            <template slot-scope="scope">
              <el-tag class="big" v-bind:type="mflRange(getMayorImpacto(scope.row).mfl)">{{
                getMayorImpacto(scope.row).mfl
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="FS">
            <template slot-scope="scope">{{
              getMayorImpacto(scope.row).impacto &&
              getMayorImpacto(scope.row).impacto.factor_severidad
            }}</template>
          </el-table-column>
          <el-table-column width="100" align="center" label="FP">
            <template slot-scope="scope">{{
              getMayorImpacto(scope.row).impacto &&
              getMayorImpacto(scope.row).impacto.factor_probabilidad
            }}</template>
          </el-table-column>
          <el-table-column width="100" align="center" label="RRR">
            <template slot-scope="scope">
              <el-tag class="big" type="gray">{{
                getMayorImpacto(scope.row).rrr
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="NSR">
            <template slot-scope="scope">{{
              getMayorImpacto(scope.row).impacto &&
              getMayorImpacto(scope.row).impacto.nivel_severidad
            }}</template>
          </el-table-column>
        </el-table>

        <InventarioBowtie :editRisk="editRisk" :saveChange="saveChange" :action="action" :onAcept="addCustomRisk"
          :onClose="handleClose" :visibleSync="openDialogBowtie" :editable="true" :risk="newCustomRisk"
          :allStandardRisks="risks" :riskItem="riskItem" :closeDialogCustomRisk="closeDialogCustomRisk" />
        <br />
        <div v-if="taskName !== ''">
          <el-alert v-if="cantidadRiesgos === 0" title="Atención" type="warning"
            :description="`No hay ningún riesgo asociado a la tarea ${taskName}, para continuar debes agregar como mínimo uno.`"
            show-icon :closable="false"></el-alert>
        </div>
        <br />
        <div class="text-right">
          <el-button type="info" size="medium" @click="previousStep" class="big-submit">Regresar</el-button>
          <el-button class="big-submit" size="medium" type="primary" :loading="isLoading" @click="nextStep"
            :disabled="cantidadRiesgos === 0 || taskName === ''">Siguiente</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- Dialogs -->
    <dialogTableSecurityRisks :onCancel="handleClose" :onAcept="riskItem" :risks="estandarizedSecurityRisks"
      :visibleSync="dialogAddSecurityRisk" :title="$t('Riesgos estandarizados de Seguridad')"
      :handleSelectionChange="handleSelectionChange" />

    <dialogTableSecurityRisks :onCancel="handleClose" :onAcept="riskItem" :risks="estandarizedHealthRisks"
      :visibleSync="dialogAddHealthRisks" :title="$t('Riesgos estandarizados de Salud')"
      :handleSelectionChange="handleSelectionChange" />

    <dialogTableSecurityRisks :onCancel="handleClose" :onAcept="riskItem" :risks="estandarizedMedioambienteRisks"
      :visibleSync="dialogAddMedioambienteRisks" :title="$t('Riesgos estandarizados de Medioambiente')"
      :handleSelectionChange="handleSelectionChange" />

    <el-dialog :before-close="handleClose" title="Agregando" :visible="dialogNewCustomRisk">
      <el-form>
        <el-form-item label="Nombre">
          <el-input class="with-help-box" v-model="formCustomRisk.nombre" auto-complete="on"
            @keydown.native.enter.prevent @keyup.native.enter="addCustomRisk('formCustomRisk')" />
          <el-popover class="help-box" placement="right" title="Nombre del riesgo" width="200" trigger="hover" content="Escriba el nombre del 'Riesgo o Aspecto Ambiental' que desee agregar.
            El nombre debe ser breve, claro y preciso, de no más de una línea.">
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="Tipo">
          <el-radio-group v-model="formCustomRisk.tipo" class="with-help-box">
            <el-radio-button label="Salud y Seguridad"></el-radio-button>
            <el-radio-button label="Medioambiental"></el-radio-button>
          </el-radio-group>
          <el-popover class="help-box" placement="right" title="Tipo del riesgo" width="200" trigger="hover" :content="$t(
            'Seleccione el tipo del \'Riesgo o Aspecto Ambiental\' que desee agregar. Solo puedes seleccionar uno.'
          )
            ">
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <p v-if="standard_risk_found">{{ standard_risk_message }}</p>
        <div v-if="!noStandardRiskLeft">
          <div v-for="standard_risk in standard_risks" :key="standard_risk.name">
            <label>
              <input type="radio" name="standard_risks" :value="standard_risk.id" v-model="formCustomRisk.standardRisk"
                @change="enableStandardRiskButton" />
              {{ standard_risk.name }}
            </label>
          </div>
        </div>
        <div v-if="noStandardRiskLeft">
          <ul v-for="standard_risk in standard_risks_original" :key="standard_risk.name">
            <li>{{ standard_risk.name }}</li>
          </ul>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogCustomRisk">Cancelar</el-button>
        <el-button :disabled="!standardRiskButtonEnabled" type="primary" @click="addCustomRiskSRR('formCustomRisk')"
          v-if="standard_risk_found">Agregar Riesgo Estandarizado</el-button>
        <el-button type="primary" @click="addCustomRisk('formCustomRisk')" v-if="!standard_risk_found">Agregar
        </el-button>
      </span>
    </el-dialog>

    <el-dialog :before-close="handleClose" title="Editando" :visible="dialogEditCustomRisk">
      <el-form>
        <el-form-item label="Nombre">
          <el-input v-model="formCustomRisk.nombre" class="with-help-box" auto-complete="on" />
          <el-popover class="help-box" placement="right" title="Nombre del riesgo" width="200" trigger="hover" content="Escriba el nombre del 'Riesgo o Aspecto Ambiental'.
            El nombre debe ser breve, claro y preciso, de no más de una línea.">
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="Tipo">
          <el-radio-group v-model="formCustomRisk.tipo" class="with-help-box">
            <el-radio-button label="Salud y Seguridad"></el-radio-button>
            <el-radio-button label="Medioambiental"></el-radio-button>
          </el-radio-group>
          <el-popover class="help-box" placement="right" title="Tipo del riesgo" width="200" trigger="hover" content="Seleccione el tipo del 'Riesgo o Aspecto Ambiental'.
            Solo puedes seleccionar uno.">
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogEditCustomRisk()">Cancelar</el-button>
        <el-button type="primary" @click="editCustomRisk('formCustomRisk')">Modificar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Atención" :visible.sync="dialogError" width="42%" :before-close="handleClose">
      <h1>Para continuar debes completar la siguiente información</h1>
      <br />
      <ol>
        <li v-for="(error, index) in errores" :key="index">{{ error }}</li>
      </ol>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="dialogError = false">Cerrar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Listado de tareas" :visible.sync="dialogCopyRisk" width="52%" top="5%"
      :before-close="handleClose">
      <div style="padding-top: 8px">
        <div v-if="multiple === false">
          {{
            ` Usted en este momento se encuentra realizando la copia del siguiente riesgo`
          }}
          "{{ copy_risk.nombre }}", A continuación debe seleccionar la tarea en la
          cúal desea asignarlo.
        </div>
        <div v-if="multiple === true">
          Usted en este momento se encuentra realizando la copia de los siguientes riesgos y a continuación debe
          seleccionar la tarea en la cúal desea asignarlos.
          <ul>
            <li v-for="(item, index) in riesgos" :key="`riesgo_select-${index}`">{{ item.nombre }}</li>
          </ul>
        </div>
        <el-table empty-text="No se encuentran más tareas en el inventario" height="380"
          header-cell-class-name="header-cell-class-table-gray" border :data="all_tasks"
          style="width: 100%; margin-top: 30px">
          <el-table-column prop="nombre" label="Nombre"></el-table-column>
          <el-table-column align="center" label="Operaciones" width="170">
            <template slot-scope="scope">
              <el-button type="primary" @click="duplicarRiesgo(scope.row.id)" size="small">Seleccionar</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCopyRisk = false">Cancelar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Listado de inventarios" :visible.sync="copyInventoryTask" width="80%" :before-close="handleClose">
      <el-form :inline="true" style="margin-top: 15px;" onsubmit="return false;" label-position="left">
        <el-form-item label="Tipo de contrato">
          <el-select class="tipoContrato" size="small" v-model="contractType" placeholder="Seleccione tipo">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 15px;" label="Búsqueda avanzada">
          <el-input :placeholder="$t('Búsqueda por nombre')" prefix-icon="el-icon-search" v-model="search"
            class="search" size="small" />
        </el-form-item>
      </el-form>
      <el-alert type="info" show-icon>
        <b>Considerar los siguientes puntos.</b>
        <ol>
          <li>Es obligatorio que el inventario destino (donde se va copiar la información desde otros inventarios) debe
            estar
            en estado Borrador (editable).</li>
          <li>Si el inventario está en estado “No iniciado” no se podrá copiar información desde otros inventarios, como
            se
            señala en el primer punto el inventario debe estar en borrador, para esto debe contar al menos con la
            primera
            tarea creada de forma manual por el coordinador responsable.</li>
          <li>Esta función también aplica para inventarios que se encuentran aprobados y requieren ser actualizados en
            plataforma, recordar que antes de iniciar el proceso de copiado de información desde otros inventarios se
            debe
            dejar el inventario destino nuevamente en estado borrador.</li>
        </ol>
      </el-alert>
      <el-table v-loading="loading_inv" style="margin-top: 15px;"
        :data="paginar === false ? inventarios : paginarInventarios()" class="inventoryTable" :max-height="700"
        :header-cell-style="function () {
          return 'background-color: #242424; color: white; padding: 0px; border-width: 2px;';
        }
          ">
        <el-table-column :label="$t('Nombre')" prop="nombre" sortable></el-table-column>
        <el-table-column label="Estado" align="center" width="190">
          <template slot-scope="scope">
            <span :class="`safety-tag inventario_estado inventario_estado_${JSON.stringify(scope.row.inventario) !== 'null'
              ? scope.row.inventario.status
              : 'undefined'
              }`">{{ getStatus(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Estado" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="(scope.row.inventario && ![1, 2, 4, '1', '2', '4'].includes(scope.row.inventario.status))"
              @click="copiarRiesgoInventario(scope.row)" size="small" type="warning">Seleccionar</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <br />
      <center>
        <el-pagination :current-page="page" @prev-click="backPage" @next-click="nextPage" @current-change="currentPage"
          :page-size="5" layout="prev, pager, next" :total="totalPage" />
      </center>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="Listado de tareas" :visible.sync="dialogtasks" width="80%"
      :before-close="handleClose">

      <el-table style="margin-top: 15px;" :data="listado_tareas" class="inventoryTable" :max-height="700"
        :header-cell-style="function () {
          return 'background-color: #242424; color: white; padding: 0px; border-width: 2px;';
        }
          ">
        <el-table-column :label="$t('Nombre')" prop="nombre" sortable></el-table-column>
        <el-table-column label="Opciones" align="center" width="190">
          <template slot-scope="scope">
            <el-button @click="copiarTareaRiesgoInventario(scope.row)" size="small"
              type="warning">Seleccionar</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
      </span>
    </el-dialog>

    <el-dialog width="70%" :before-close="handleClose" title="Reemplazo de riesgos" :visible="dialogReplaceRisk">
      <div style="margin-top: 10px;"><i class="el-icon-info" style="margin-right: 4px;"></i><span>Seleccione en la tabla
          los
          riesgos que desea que se reemplacen (Puede seleccionar más de uno)</span></div>
      <el-input v-model="search_risks" size="small" placeholder="Búsqueda por tarea o riesgo"
        style="margin-top: 15px;" />
      <el-table stripe header-cell-class-name="header-cell-class-table-gray"
        :data="getDataInventario().filter(data => !search_risks || data.tarea.toLowerCase().includes(search_risks.toLowerCase()) || data.riesgo.toLowerCase().includes(search_risks.toLowerCase()))"
        style="width: 100%; margin-top: 20px;" height="400" ref="multipleTableCopyRisks"
        @selection-change="handleSelectionChangeCopyRisks">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="tarea" label="Tarea">
        </el-table-column>
        <el-table-column prop="riesgo" label="Riesgo">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogReplaceRisk = false">Cancelar</el-button>
        <el-button type="primary" @click="replaceRisks">Guardar y reemplazar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImagesLoaded from "vue-images-loaded";
import uuid from "uuid/v4";

import dialogTableSecurityRisks from "@/components/dialogTableRisks.vue";
import InventarioBowtie from "@/components/DialogInventarioBowtie.vue";
import StepsInventario from "@/components/StepsInventario.vue";
import axios from "axios";

export default {
  name: "FirstStep",
  data() {
    return {
      cambios_load: false,
      search: "",
      riesgosReplace: [],
      dialogReplaceRisk: false,
      render: 0,
      tareas: [],
      editRisk: false,
      taskName:
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].nombre,
      errores: [],
      dialogError: false,
      componentKey: 0,
      indexEdit: null,
      action: "",
      newCustomRisk: {
        _id: "",
        nombre: "",
        tipo: null,
        standardRisk: false,
        material: false,
        causas: [],
        custom: true,
        impactos: [],
        escenario: "",
        escenario_residual: "",
        escenario_mfl: "",
        faena_id: "",
        medioambiental: false,
        medioambiente: {
          responsable: "",
          condicion: "",
          evento: "",
          equipo: "",
        },
        evaluadores: [],
        status: 0,
        status_step: 0,
        status_by: null,
        status_position: null,
        status_message: null,
      },
      openDialogBowtie: false,
      estandarizedSecurityRisks: [],
      estandarizedHealthRisks: [],
      estandarizedMedioambienteRisks: [],
      risksSelected: [],
      dialogAddMedioambienteRisks: false,
      dialogAddSecurityRisk: false,
      dialogAddHealthRisks: false,
      dialogNewCustomRisk: false,
      dialogEditCustomRisk: false,
      filterSelected: "*",
      standard_risks: [],
      standard_risks_original: [],
      standard_risk_message: "",
      standard_risk_found: false,
      standardRiskButtonEnabled: false,
      noStandardRiskLeft: false,
      formCustomRisk: {
        nombre: null,
        tipo: null,
        standardRisk: null,
      },
      isLoading: false,
      copy_risk: {},
      all_tasks: [],
      dialogCopyRisk: false,
      riesgos: [],
      multiple: false,

      tarea_selected: {},
      riesgo_selected: {},
      dialogtasks: false,
      inventario_selected: {},
      listado_tareas: [],
      copyInventoryTask: false,
      inventarios: [],
      page: 1,
      totalPage: 0,
      paginar: false,
      vencido: false,
      contractType: "Contratista",
      options: [
        {
          value: "Contratista",
          label: "Contratista",
        },
        {
          value: "Propio",
          label: "Propio",
        },
      ],
      inventario_estado: {
        0: "Borrador",
        1: "En revisión",
        2: "Aprobado",
        3: "Importado Borrador",
        4: "Validación de Medioambiente",
      },
      loading_inv: false,
      search_risks: "",
    };
  },
  watch: {
    search_risks() {
      this.debounceInputSearch();
    },
    contractType() {
      this.page = 1;
      this.listadoInventarios(this.page, this.search);
    },
  },
  created() {
    this.$store.dispatch("getAllRisks");
    this.$store.dispatch(
      "setSubTitle",
      this.$t(
        `Creando Inventario de Riesgos / ${this.$store.getters.actualContract.nombre}`
      )
    );
    this.$store.dispatch("getAreasFaena");
  },
  components: {
    StepsInventario,
    dialogTableSecurityRisks,
    InventarioBowtie,
  },
  directives: {
    ImagesLoaded,
  },
  computed: {
    role() {
      return this.$store.getters.role;
    },
    mel() {
      return this.role.faena_id === "5a6f78337b772dcfe68241d5";
    },
    cantidadRiesgos() {
      if (
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos
      ) {
        return this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.length;
      }
      return 0;
    },
    areas() {
      return this.$store.getters.areas;
    },
    securityRisks() {
      return this.risks.filter(
        (el) => el.impactos[0].categoria.toLowerCase() === "seguridad"
      );
    },
    healthRisks() {
      return this.risks.filter(
        (el) => el.impactos[0].categoria.toLowerCase() === "salud"
      );
    },
    medioambienteRisks() {
      return this.risks.filter(
        (el) =>
          el.impactos[0].categoria.toLowerCase() === "medioambiente" ||
          el.impactos[0].categoria.toLowerCase() === "medioambiental"
      );
    },
    task() {
      return (
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].id ||
        this.$store.getters.inventario.tareas[
        this.$store.getters.selectedIndexTask
        ] ||
        {}
      );
    },
    taskId() {
      return this.task._id || this.task.id;
    },
    contract() {
      return this.$store.getters.actualContract;
    },
    contractId() {
      return this.contract._id;
    },
    ...mapGetters({
      risks: "allRisks",
      isLoggedIn: "isLoggedIn",
    }),
  },
  methods: {
    async saveRiskDatabase(riesgo, id_tarea) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var resp = await axios.post(`/inventarios/addRiskInTask`, {
        id_inventario: this.$store.getters.inventario._id,
        riesgo: riesgo,
        id_tarea: id_tarea
      }, config);

      if (resp.data.status === true) {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: "Riesgo guardado exitosamente",
          type: "success",
        });
      } else {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: "Riesgo no pudo ser guardado",
          type: "warning",
        });
      }
    },
    async updateTask(data, id_tarea) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var resp = await axios.post(`/inventarios/updateTask`, {
        id_inventario: this.$store.getters.inventario._id,
        data: data,
        id_tarea: id_tarea
      }, config);

      if (resp.data.status === true) {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: "Tarea actualizada exitosamente",
          type: "success",
        });
      } else {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: "Tarea no pudo ser actualizada",
          type: "warning",
        });
      }
    },
    replaceRisks() {
      var lista = "";
      this.riesgosReplace.forEach(d => {
        lista = lista + `
          <tr><td style="padding: 5px;">${d.tarea}</td><td style="padding: 5px;">${d.riesgo}</td></tr>
        `;
      });
      this.$confirm(
        `¿Está seguro que seleccionó todos los riesgos que desea modificar? 
        <br> 
        <div style="margin-top: 8px;"><small><b>RIESGOS SELECCIONADOS</b></small></div>
        <div style="overflow: scroll; height: 400px">
        <table style="margin-top: 8px; border: 1px solid black; border-collapse: collapse;" border="1">
          ${lista}
        </table></div>`,
        'Advertencia',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Regresar',
        },
      )
        .then(async () => {
          this.resetStatusRisk();
          var tarea = this.$store.getters.inventario.tareas[this.$store.getters.selectedIndexTask];
          this.riesgosReplace.push({ tarea_id: tarea.id || tarea._id, tarea: tarea.nombre, riesgo_id: this.newCustomRisk._id || this.newCustomRisk.id, riesgo: this.newCustomRisk.nombre })
          this.$store.dispatch("replaceRisks", { selected: this.riesgosReplace, riesgo: this.newCustomRisk });
          this.forceRerender();
          this.handleClose();
          this.saveInventory();
        });
    },
    handleSelectionChangeCopyRisks(val) {
      this.riesgosReplace = val;
    },
    getDataInventario() {
      var data = [];
      this.$store.getters.inventario.tareas.forEach(t => {
        if (t.riesgos) {
          t.riesgos.forEach(r => {
            if (this.newCustomRisk._id !== r._id) {
              data.push({ tarea_id: t._id || t.id, tarea: t.nombre, riesgo_id: r._id || r.id, riesgo: r.nombre });
            }
          });
        }
      });
      return data;
    },
    async getInventory() {
      await this.$store.dispatch("getInventory", this.contract).then(() => {
      });
    },
    async copiarTareaRiesgoInventario(tarea) {
      this.tarea_selected = tarea;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      this.$confirm(
        `Estimado usuario coordinador, por favor, considere el impacto que los diferentes escenarios, pueden generar en la evaluación del riesgo. ¿Deseas Continuar?`,
        'Advertencia',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning',
        },
      )
        .then(async () => {
          if (this.riesgo_selected.custom === true) {
            this.riesgo_selected._id = uuid();
            this.riesgo_selected.status = 0;
            this.riesgo_selected.status_step = 0;
            this.riesgo_selected.status_by = null;
            this.riesgo_selected.status_position = null;
            this.riesgo_selected.status_message = null;
            this.riesgo_selected.status_step_approve = [];
            this.riesgo_selected.status_history = null;
            this.riesgo_selected.status_updated_at = null;
          }
          await axios.post(`/inventarios/copiarTareaRiesgoInventario`, {
            id_inventory: this.inventario_selected._id,
            tarea: this.tarea_selected,
            riesgo: this.riesgo_selected
          }, config);
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Riesgo copiado exitosamente",
            type: "success",
          });
          this.getInventory();
          this.handleClose();
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async copiarRiesgoInventario(row) {
      this.inventario_selected = row.inventario;
      this.inventario_selected["nombre"] = row["nombre"];
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      var resp = await axios.post(`/inventarios/getTasksInventory`, {
        _id: row.inventario._id,
      }, config);

      this.listado_tareas = resp.data.length > 0 ? resp.data[0]["tareas"] : [];
      this.dialogtasks = true;
    },
    debounceInputSearch: _.debounce(function () {
      this.page = 1;
      this.listadoInventarios(this.page, this.search);
    }, 1200),
    getStatus(row) {
      if (!row.inventario) {
        return "No iniciado";
      }
      if (row.inventario.wasApproved === true) {
        if (row.inventario.status === 1 || row.inventario.status === 0) {
          return "Aprobado en actualización";
        }
      }
      return this.inventario_estado[row.inventario.status];
    },
    paginarInventarios() {
      return this.inventarios.slice((this.page - 1) * 5, this.page * 5);
    },
    currentPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    listadoInventarios(page, search) {
      const self = this;
      this.loading_inv = true;
      let url = `/contratos/byUFAER?vencido=${this.vencido}&userId=${this.$store.getters.user._id}&faenaId=${this.$store.getters.role.faena_id}`;
      url = this.$store.getters.role.admin
        ? `${url}&role=admin`
        : this.$store.getters.role.area_id === "GeneralAreasRoles"
          ? `${url}&role=allAreas`
          : `${url}&role=${this.$store.getters.role.role}`;
      url += `&actualRole=${this.$store.getters.role.role}`;
      if (this.$store.getters.role.area_id) {
        url = `${url}&areaId=${this.$store.getters.role.area_id}`;
      }
      if (this.$store.getters.role.empresa_id) {
        url = `${url}&empresaId=${this.$store.getters.role.empresa_id}`;
      }
      axios
        .get(
          `${url}&page=${page}&tipo=${this.contractType}&search=${search === "" ? undefined : search
          }`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          self.inventarios = response.data.contratos.results;
          self.totalPage = response.data.contratos.total;
          self.paginar = response.data.contratos.paginar;
          self.loading_inv = false;
        });
    },
    copyRisks(riesgo) {
      this.riesgo_selected = riesgo;
      this.riesgo_selected["_id"] = this.generateUUID();
      this.listadoInventarios(1, "");
      this.copyInventoryTask = true;
    },
    generateUUID() {
      var d = new Date().getTime();
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    },
    async moveUp(index, risk) {
      this.$store.dispatch("upRisk", index);
      this.render++;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var resp = await axios.post(`/inventarios/setPositionRisk`, {
        id_inventario: this.$store.getters.inventario._id,
        indice: index === 0 ? 0 : index - 1,
        riesgo: risk,
        id_riesgo: risk.id || risk._id,
        id_tarea: this.taskId,

      }, config);

      if (resp.data.status === true) {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: resp.data.mensaje,
          type: "success",
        });
      }
    },
    async moveDown(index, risk) {
      this.$store.dispatch("downRisk", index);
      this.render++;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var resp = await axios.post(`/inventarios/setPositionRisk`, {
        id_inventario: this.$store.getters.inventario._id,
        indice: index + 1,
        riesgo: risk,
        id_riesgo: risk.id || risk._id,
        id_tarea: this.taskId,

      }, config);

      if (resp.data.status === true) {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: resp.data.mensaje,
          type: "success",
        });
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    openCopyRiskList() {
      this.riesgos.forEach(r => {
        if (r.custom === true) {
          r._id = uuid();
          r.status = 0;
          r.status_step = 0;
          r.status_by = null;
          r.status_position = null;
          r.status_message = null;
          r.status_step_approve = [];
          r.status_history = null;
          r.status_updated_at = null;
        }
      });
      this.all_tasks = [];
      this.$store.getters.inventario.tareas.forEach((t) => {
        this.all_tasks.push({ id: t._id || t.id, nombre: t.nombre });
      });
      this.all_tasks.splice(this.$store.getters.selectedIndexTask, 1);
      this.multiple = true;
      this.dialogCopyRisk = true;
    },
    handleSelectionChangeTareas(val) {
      this.riesgos = JSON.parse(JSON.stringify(val));
    },
    resetTareaName() {
      this.taskName = "";
    },
    duplicarRiesgo(tarea_id) {
      let nombre_tarea = "";
      if (this.multiple === false) {
        const nombre_riesgo = this.copy_risk.nombre;
        this.$confirm(
          `Estás a punto de duplicar el riesgo "${nombre_riesgo}". Continuar?`,
          "Advertencia",
          {
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        ).then(async () => {
          this.$store.getters.inventario.tareas.forEach((t, index) => {
            if (t.id === tarea_id || t._id === tarea_id) {
              nombre_tarea = t.nombre;
              this.$store.dispatch("duplicateRisk", {
                risk: this.copy_risk,
                index,
              });
              this.saveRiskDatabase(this.copy_risk, tarea_id);
            }
          });
          this.handleClose();
          this.copy_risk = {};
          this.all_tasks = [];
          this.riesgos = [];
          //this.saveInventory();
          this.toggleSelection();
        });
      }
      if (this.multiple === true) {
        this.$confirm(
          `Estás a punto de duplicar los riesgos seleccionados. Continuar?`,
          "Advertencia",
          {
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        ).then(() => {
          this.$store.getters.inventario.tareas.forEach((t, index) => {
            if (t.id === tarea_id || t._id === tarea_id) {
              nombre_tarea = t.nombre;
              this.riesgos.forEach(r => {
                this.$store.dispatch("duplicateRisk", {
                  risk: r,
                  index,
                });
                this.saveRiskDatabase(r, tarea_id);
              });
            }
          });
          this.handleClose();
          this.copy_risk = {};
          this.all_tasks = [];
          this.riesgos = [];
          //this.saveInventory();
          this.toggleSelection();
        });
      }
    },
    openCopyRisk(risk) {
      const riesgo = JSON.parse(JSON.stringify(risk));
      if (riesgo.custom === true) {
        riesgo._id = uuid();
        riesgo.status = 0;
        riesgo.status_step = 0;
        riesgo.status_by = null;
        riesgo.status_position = null;
        riesgo.status_message = null;
        riesgo.status_step_approve = [];
        riesgo.status_history = null;
        riesgo.status_updated_at = null;
      }
      this.copy_risk = riesgo;
      this.all_tasks = [];
      this.$store.getters.inventario.tareas.forEach((t) => {
        this.all_tasks.push({ id: t._id || t.id, nombre: t.nombre });
      });
      this.all_tasks.splice(this.$store.getters.selectedIndexTask, 1);
      this.multiple = false;
      this.dialogCopyRisk = true;
    },
    assignTaskName() {
      var tarea = this.$store.getters.inventario.tareas[this.$store.getters.selectedIndexTask];
      this.$store.dispatch("editTask", {
        taskId:
          this.$store.getters.inventario.tareas[
            this.$store.getters.selectedIndexTask
          ].id ||
          this.$store.getters.inventario.tareas[
            this.$store.getters.selectedIndexTask
          ]._id,
        nombre: this.taskName
      });
      this.updateTask({ nombre: this.taskName }, tarea.id || tarea._id)
      // this.saveInventory();
    },
    pintar({ row, column, rowIndex, columnIndex }) {
      let classes = "cellClassTablaPloma ";
      if (columnIndex === 1) {
        if (row.custom === true) {
          classes += "colorCustom";
        } else if (row.impactos[0].categoria === "Seguridad" && !row.custom) {
          classes += "colorSeguridad";
        } else if (row.impactos[0].categoria === "Salud" && !row.custom) {
          classes += "colorSalud";
        } else if (
          row.impactos[0].categoria === "Medioambiente" &&
          !row.custom
        ) {
          classes += "colorMedioambiente";
        }
      }
      return classes;
    },
    saveInventory() {
      this.cambios_load = true;
      this.$store.dispatch("createOrUpdateDraft").then((response) => {
        if (response.success) {
          this.$store.dispatch("clearUserContract");
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Cambios guardados exitosamente",
            type: "success",
          });
          this.cambios_load = false;
        } else {
          this.$alert(response.message, this.$t("Error"), {
            type: "error",
          });
          this.cambios_load = false;
        }
      });
    },
    saveChange(risk) {
      risk.custom = true;
      if (this.isRiskReady(risk).status === true) {
        this.$confirm(
          `¿Desea copiar la información que fue modificada del riesgo en otros riesgos del inventario ?`,
          'Información',
          {
            confirmButtonText: 'EDITAR OTROS RIESGOS',
            cancelButtonText: 'SOLO EDITAR ESTE RIESGO',
            closeOnClickModal: false,
            type: 'warning',
          },
        )
          .then(async () => {
            this.dialogReplaceRisk = true;
          })
          .catch(async (err) => {
            var tarea = this.$store.getters.inventario.tareas[this.$store.getters.selectedIndexTask];
            this.resetStatusRisk();
            this.$store.dispatch("editCustomRisk", risk);
            this.forceRerender();
            this.handleClose();

            const config = {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            };
            var resp = await axios.post(`/inventarios/updateRisksInv`, {
              id_inventario: this.$store.getters.inventario._id,
              riesgo: risk,
              id_riesgo: risk._id,
              id_tarea: tarea.id || tarea._id
            }, config);

            if (resp.data.status === true) {
              this.$notify({
                duration: 3000,
                title: "Atención",
                message: `Riesgo ${risk.nombre} modificado exitosamente`,
                type: "success",
              });
            } else {
              this.$notify({
                duration: 3000,
                title: "Atención",
                message: "Riesgo no pudo ser modificado",
                type: "warning",
              });
            }
          });
      } else {
        let textError = "";
        for (
          let index = 0;
          index < this.isRiskReady(risk).errors.length;
          index++
        ) {
          textError = `${textError}<li class="listaError">${this.isRiskReady(risk).errors[index]
            }</li>`;
        }
        this.$alert(`<ol class="listaError">${textError}</ol>`, "Atención", {
          type: "error",
          dangerouslyUseHTMLString: true,
        });
      }
    },
    resetStatusRisk() {
      this.newCustomRisk["custom"] = true;
      this.newCustomRisk.status = 0;
      this.newCustomRisk.status_step = 0;
      this.newCustomRisk.status_by = null;
      this.newCustomRisk.status_position = null;
      this.newCustomRisk.status_message = null;
      this.newCustomRisk.status_updated_at = null;
      this.newCustomRisk.status_history = [];
    },
    forceRerender() {
      this.componentKey += 1;
    },
    validarRiesgosSeguridad() {
      this.estandarizedSecurityRisks = JSON.parse(
        JSON.stringify(this.securityRisks)
      );
      if (
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos
      ) {
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.forEach((element) => {
          const index = this.estandarizedSecurityRisks.findIndex(
            (x) => x._id === element._id
          );
          if (index !== -1) {
            this.estandarizedSecurityRisks.splice(index, 1);
          }
        });
      }
    },
    validarRiesgosSalud() {
      this.estandarizedHealthRisks = JSON.parse(
        JSON.stringify(this.healthRisks)
      );
      if (
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos
      ) {
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.forEach((element) => {
          const index = this.estandarizedHealthRisks.findIndex(
            (x) => x._id === element._id
          );
          if (index !== -1) {
            this.estandarizedHealthRisks.splice(index, 1);
          }
        });
      }
    },
    validarRiesgosMedioambiente() {
      this.estandarizedMedioambienteRisks = JSON.parse(
        JSON.stringify(this.medioambienteRisks)
      );
      if (
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos
      ) {
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.forEach((element) => {
          const index = this.estandarizedMedioambienteRisks.findIndex(
            (x) => x._id === element._id
          );
          if (index !== -1) {
            this.estandarizedMedioambienteRisks.splice(index, 1);
          }
        });
      }
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach((control) => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map((key) => ({
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id,
      }));
      return controles;
    },
    handleSelectionChange(risks) {
      this.risksSelected = risks;
    },
    openDialogAddSecurityRisk() {
      this.dialogAddSecurityRisk = true;
      this.validarRiesgosSeguridad();
    },
    openDialogAddCustomRisk() {
      this.action = "add";
      this.openDialogBowtie = true;
      this.setIdRisk();
    },
    openDialogAddHealthRisks() {
      this.dialogAddHealthRisks = true;
      this.validarRiesgosSalud();
    },
    openDialogAddMediambienteRisks() {
      this.dialogAddMedioambienteRisks = true;
      this.validarRiesgosMedioambiente();
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    enableStandardRiskButton() {
      this.standardRiskButtonEnabled = true;
    },
    handleClose() {
      this.dialogReplaceRisk = false;
      this.search = "";
      this.dialogtasks = false;
      this.copyInventoryTask = false;
      this.dialogError = false;
      this.dialogCopyRisk = false;
      this.openDialogBowtie = false;
      this.dialogNewCustomRisk = false;
      this.dialogEditCustomRisk = false;
      this.dialogAddSecurityRisk = false;
      this.risksSelected = [];
      this.dialogAddHealthRisks = false;
      this.dialogAddMedioambienteRisks = false;
      this.newCustomRisk = {
        _id: "",
        nombre: "",
        tipo: "",
        standardRisk: false,
        material: false,
        causas: [],
        custom: true,
        impactos: [],
        escenario: "",
        faena_id: "",
        medioambiental: false,
        medioambiente: {
          responsable: "",
          condicion: "",
          evento: "",
          equipo: "",
        },
        evaluadores: [],
        causas: [],
        status: 0,
        status_step: 0,
        status_by: null,
        status_position: null,
        status_message: null,
      };
      this.editRisk = false;
    },
    openEditRisk(risk) {
      if (!risk.medioambiente) {
        risk.medioambiente = {};
        risk.medioambiente.responsable = "";
        risk.medioambiente.condicion = "";
        risk.medioambiente.evento = "";
        risk.medioambiente.equipo = "";
      }
      this.newCustomRisk = JSON.parse(JSON.stringify(risk));
      this.action = "edit";
      this.openDialogBowtie = true;
      this.editRisk = true;
    },
    filter(option) {
      this.filterSelected = option;
      this.$refs.cpt2.filter("byArea");
    },
    riskItem() {
      var tarea = this.$store.getters.inventario.tareas[this.$store.getters.selectedIndexTask];
      this.risksSelected.forEach((element) => {
        this.$store.dispatch("addRisk", element);
        this.saveRiskDatabase(element, tarea._id || tarea.id);
      });
      //this.saveInventory();
      this.handleClose();
    },

    addCustomRisk() {
      var tarea = this.$store.getters.inventario.tareas[this.$store.getters.selectedIndexTask];
      const findRisk = this.$store.getters.inventario.tareas[
        this.$store.getters.selectedIndexTask
      ].riesgos
        ? this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.find(
          (risk) =>
            risk.nombre.toLowerCase() ===
            this.newCustomRisk.nombre.toLowerCase()
        )
        : false;
      if (findRisk) {
        this.$message({
          message:
            "Advertencia, El riesgo que estás ingresando ya se encuentra registrado en el inventario, por favor verifíquelo.",
          type: "warning",
        });
      } else if (this.isRiskReady(this.newCustomRisk).status === true) {
        this.$store.dispatch("addRisk", this.newCustomRisk);
        this.saveRiskDatabase(this.newCustomRisk, tarea._id || tarea.id);
        //this.saveInventory();
        this.handleClose();
      } else {
        this.errores = [];
        for (
          let index = 0;
          index < this.isRiskReady(this.newCustomRisk).errors.length;
          index++
        ) {
          this.errores.push(this.isRiskReady(this.newCustomRisk).errors[index]);
        }
        this.dialogError = true;
      }
    },
    isRiskReady(risk) {
      const errors = [];
      if (risk && risk.custom === true) {
        // Verificar que existan impactos en el riesgo
        if (!risk.impactos || risk.impactos.length === 0) {
          errors.push(`${this.$t("No hay impactos asociados")}`);
        }
        // Verifica que existan causas en el riesgo
        if (!risk.causas || risk.causas.length === 0) {
          errors.push(`${this.$t("No hay causas asociadas")}`);
        }
        if (risk.impactos && risk.impactos.length > 0) {
          if ([4, 5, "4", "5"].includes(risk.impactos[0]["mfl"])) {
            let controles = [];
            risk.impactos.forEach((imp) => {
              if (imp.controles_mitigadores) {
                imp.controles_mitigadores.forEach((cm) => {
                  if (cm.critico === true) {
                    controles.push(cm);
                  }
                });
              }
            });

            risk.causas.forEach((ca) => {
              if (ca.controles_preventivos) {
                ca.controles_preventivos.forEach((cp) => {
                  if (cp.critico === true) {
                    controles.push(cp);
                  }
                });
              }
            });

            if (controles.length === 0) {
              errors.push(
                `${this.$t(
                  "El Nivel MFL 4 considerado Riesgo Material debe llevar al menos 1 control crítico"
                )}`
              );
            }
          }
        }

        // Verifica que exista nombre en el riesgo
        if (risk.nombre === "") {
          errors.push(`${this.$t("No hay un nombre asociado al riesgo")}`);
        }
        // Verifica que exista nombre en el riesgo
        if (risk.tipo === null) {
          errors.push(`${this.$t("No se ha asignado un tipo al riesgo")}`);
        }

        // Verifica que todas las causas tengan controles preventivos
        if (risk.causas.length > 0) {
          risk.causas.forEach((causa) => {
            if (
              !causa.controles_preventivos ||
              causa.controles_preventivos.length === 0
            ) {
              errors.push(
                `La causa ${this.$t("Causa")} '${causa.nombre}' ${this.$t(
                  "no tiene controles preventivos asociados"
                )}`
              );
            }
          });
        } else {
          errors.push(`${this.$t("No hay controles preventivos asociados")}`);
        }

        // Valida que tenga impactos asociados
        risk.impactos.forEach((impacto) => {
          if (
            !impacto.controles_mitigadores ||
            impacto.controles_mitigadores.length === 0
          ) {
            errors.push(
              `${this.$t("Impacto")} '${impacto.categoria}' ${this.$t(
                "no tiene controles mitigadores asociados"
              )}`
            );
          }
        });

        // Valida escenarios escenario_residual: '', escenario_mfl: '',
        if (!risk.escenario_residual || risk.escenario_residual === "") {
          errors.push(`${this.$t("Escenario residual")}`);
        }

        if (!risk.escenario_mfl || risk.escenario_mfl === "") {
          errors.push(`${this.$t("Escenario MFL")}`);
        }

        if (errors.length > 0) {
          return { status: false, errors };
        } else {
          return { status: true, errors };
        }

      } else {
        return { status: true, errors };
      }
    },
    setIdRisk() {
      this.newCustomRisk._id = uuid();
    },
    deleteRisk(risk) {
      this.$confirm(
        `Estás a punto de eliminar el riesgo "${risk.nombre}". Continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          var tarea = this.$store.getters.inventario.tareas[this.$store.getters.selectedIndexTask];
          this.$store.dispatch("deleteCustomRisk", risk);
          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };
          var resp = await axios.post(`/inventarios/deleteRiskInv`, {
            id_inventario: this.$store.getters.inventario._id,
            id_riesgo: risk._id,
            id_tarea: tarea.id || tarea._id
          }, config);

          if (resp.data.status === true) {
            this.$notify({
              duration: 3000,
              title: "Atención",
              message: "Riesgo eliminado exitosamente",
              type: "success",
            });
          } else {
            this.$notify({
              duration: 3000,
              title: "Atención",
              message: "Riesgo no pudo ser eliminado",
              type: "warning",
            });
          }
          //this.saveInventory();
        })
        .catch((err) => {
          this.$message({
            type: "info",
            message: "Acción cancelada",
          });
        });
    },
    closeDialogCustomRisk() {
      this.formCustomRisk.nombre = "";
      this.formCustomRisk.tipo = null;
      this.dialogNewCustomRisk = false;
      this.standard_risks = [];
      this.standard_risks_original = [];
      this.standard_risk_found = false;
      this.standard_risk_message = "";
      this.noStandardRiskLeft = false;
      this.formCustomRisk.standardRisk = null;
      this.standardRiskButtonEnabled = false;
    },
    closeDialogEditCustomRisk() {
      this.formCustomRisk.nombre = "";
      this.formCustomRisk.tipo = null;
      this.dialogEditCustomRisk = false;
    },
    async previousStep() {
      if (this.taskName && this.taskName !== "") {
        this.assignTaskName();
        const url = `/inventario/${this.$store.getters.actualContract._id}/editar`;
        this.$router.push({
          path: url,
        });
      }
      if ((!this.taskName || this.taskName === "") && this.cantidadRiesgos > 0) {
        this.$message({
          type: "warning",
          message: "Se debe asignar el nombre de la tarea para regresar",
        });
      }
      if ((!this.taskName && this.cantidadRiesgos === 0) || (this.taskName === "" && this.cantidadRiesgos === 0)) {
        var tarea = this.$store.getters.inventario.tareas[this.$store.getters.selectedIndexTask];
        this.$store
          .dispatch(
            "deleteTask",
            this.$store.getters.inventario.tareas[
            this.$store.getters.selectedIndexTask
            ]
          )
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
        var resp = await axios.post(`/inventarios/deleteTaskInv`, {
          id_inventario: this.$store.getters.inventario._id,
          id_tarea: tarea.id || tarea._id
        }, config);

        if (resp.data.status === true) {
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Tarea eliminada exitosamente",
            type: "success",
          });
        } else {
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Tarea no pudo ser eliminada",
            type: "warning",
          });
        }
        //this.saveInventory();
        const url = `/inventario/${this.$store.getters.actualContract._id}/editar`;
        this.$router.push({
          path: url,
        });
      }
    },
    nextStep() {
      if (this.taskName && this.taskName !== "") {
        this.assignTaskName();
        this.isLoading = false;
        this.$router.push({ name: "secondStep" });
      } else {
        this.$message({
          type: "warning",
          message: "Se debe asignar el nombre de la tarea para continuar",
        });
      }
    },
  },
};
</script>

<style scoped>
.inventario_estado_vencido {
  background-color: #b84858;
}

.inventario_estado_undefined {
  background-color: red;
}

.inventario_estado_0 {
  background-color: grey;
}

.inventario_estado_1 {
  background-color: #e4d306;
  color: black;
}

.inventario_estado_2 {
  background-color: #6bc45b;
}

.inventario_estado_3 {
  background-color: orange;
}

.inventario_estado_4 {
  background-color: #e4d306;
}

.countRisk {
  font-size: 31px;
  color: rgb(230, 84, 0);
  font-weight: bold;
}

.nameTask {
  font-size: 21px;
}

.tableRisks {
  margin-top: 10px;
}

.cuadrado {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
}

.listaError {
  margin-left: 13px;
  padding: 0px;
  margin-bottom: 5px;
}

.alertError {
  width: 70%;
}

.fontRed {
  color: red;
}

.messageTask {
  font-size: 13px !important;
}

.title-task {
  margin-bottom: 0px !important;
}

.intermitente {
  padding: 15px 15px;
  box-shadow: 0px 0px 20px;
  color: rgb(230, 84, 0);
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {

  0%,
  100% {
    box-shadow: 0px 0px 20px;
  }

  50% {
    box-shadow: 0px 0px 0px;
  }
}
</style>

<style>
.el-loading-text {
  font-family: Arial, Helvetica, sans-serif !important;
}
</style>
